import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { adminAuthorizationGuard } from '@shared/guard/admin-authorization.guard';
import { TaxResultAccordionListPageComponent } from './pages/tax-result-accordion-list-page/tax-result-accordion-list-page.component';
import { TaxResultPageComponent } from './pages/tax-result-page/tax-result-page.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: TaxResultPageComponent,
    canActivate: [adminAuthorizationGuard],
  },
  {
    path: 'edit',
    component: TaxResultAccordionListPageComponent,
    canActivate: [adminAuthorizationGuard],
  },
  {
    path: 'view',
    component: TaxResultAccordionListPageComponent,
    canActivate: [adminAuthorizationGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TaxResultRoutingModule {}
